(function () {
	'use strict';
	angular.module('app.supplyChain')
		.controller('inventoryBurnoff', inventoryBurnoff);

	inventoryBurnoff.$inject = ['$rootScope', '$scope', '$state', '$timeout', '$location',
		'leanFilterService', 'inventoryBurnoffService', 'pageTimingService', 'storeService',
		'redirectParamsService', '$experiments', 'customerSettingService', 'tableService'
	];

	function inventoryBurnoff($rootScope, $scope, $state, $timeout, $location,
			leanFilterService, inventoryBurnoffService, pageTimingService, storeService,
			redirectParamsService, $experiments, customerSettingService, tableService) {
		// $scope is used to pass values to angular and react directives
		// vm is used to pass values to the html
		var vm = this;
		var isSupplierPortal = globalConfig.user.role === 'Supplier';
		var reportSettingsName = 'inventory-burnoff';
		var isAdmin = $rootScope.authz.isAdmin();
		var isV2 = $experiments.isEnabled('burnoff-v2');
		$scope.viewType = $state.current.data.viewType;

		// Extra query params to send to backend in data requests
		var baseExtraParams = [{ excelReportName: 'InventoryBurnoff'}];
		var extraParams = _.cloneDeep(baseExtraParams);
		// Extra drilldown query params to parse
		//Set correct navigation highlighting
		if (Object.keys($location.search()).length === 0 && redirectParamsService.hasRedirectParams() ) {
			$location.search(redirectParamsService.popRedirectParams());
		}
		var reportSettingsId = $state.params.reportId ? $state.params.reportId : undefined;

		vm.showExcel = true;
		vm.reportSettingsName = reportSettingsName;

		$scope.now = new Date();
		$scope.showMissingTargets = false;
		$scope.showChangeTargets = false;
		$scope.missingTargetMessage = '';

		var barsShown = {};

		var search = $location.search();
		$scope.showExtraData = search['showPastDue'];

		$scope.fiscalQuarters = undefined;
		var fiscalQuartersPromise = undefined;

		// Drawer functions
		$scope.handleDrawerClose = handleDrawerClose;
		$scope.broadcastDrawerExcel = broadcastDrawerExcel;
		$scope.burnoffPeriod = {};
		$scope.burnoffDrawerOpen = false;
		$scope.shiftPeriod = shiftPeriod;
		var indexWeekOffset, barIndexWeekOffset;

		$scope.$on('openBurnoffDrawer', function (event, params) {
			openDrawer(params);
		});

		$scope.$on('showChartBar', function(event, params) {
			showChartBar(params.index, params.barId);
		});

		$scope.$on('itemDrilldownClosed', function (event, params) {
			$timeout(function () {
				if (!params.isInitialClose) {
					addDrawerCloseListener();
				}
			});
		});

		$scope.filterService = leanFilterService;
		var defaultFilters = isSupplierPortal
			? []
			: [{
				'id': 'factory',
				'values': [globalConfig.factory.id],
				'isMandatory': true
			},
			{
				'id': 'itemGroupNdx',
				'values': [$scope.filterService.leanDnaAllSelected]
			},
			{
				'id': 'supplierNdx',
				'values': [$scope.filterService.leanDnaAllSelected]
			},
			{
				'id': 'buyerCode',
				'values': [$scope.filterService.leanDnaAllSelected]
			}];

		init();

		var meta = {
			reportSettingsId: reportSettingsId,
			reportSettingsName: reportSettingsName,
			excelRequest: true,
			extraParams: extraParams,
			waitForFilters: true,
			defaultFilters: defaultFilters,
			hasMandatoryFilters: isSupplierPortal,
			showExcel: vm.showExcel
		};

		vm.broadcastExcel = broadcastExcel;
		vm.getMeta = getMeta;
		vm.getData = getData;
		vm.reportName = 'Inventory burnoff';

		function navigateToBaseReport() {
			$state.go('.', {reportId: undefined});
		}
		vm.navigateToBaseReport = navigateToBaseReport;
		vm.showSaveReport = !reportSettingsId;
		vm.baseReportDisplay = vm.reportName;

		if (reportSettingsId) {
			vm.showInfo = true;
			vm.isSavedReport = true;
			vm.reportName = '';
		} else {
			vm.isSavedReport = false;
		}


		$scope.$on('reportConfigReady', function () {
			var reportSettings = getReportSettings();
			var isSavedReport = reportSettings.viewType === 'savedReports';
			if (isSavedReport) {

				vm.reportName = reportSettings.reportName;
				vm.userDescription = reportSettings.userDescription;
			}
			var options = getOptions(reportSettings);
			updateExtraParams(options);

			var unsubscribe = storeService.subscribe(function () {
				reportSettings = getReportSettings();
				if (isSavedReport) {
					vm.reportName = reportSettings.reportName;
					vm.userDescription = reportSettings.userDescription;
				}
				var newOptions = getOptions(reportSettings);
				vm.hasBanner = isV2 && newOptions.interactiveHistory;
				if (options.weeklyOrMonthly != newOptions.weeklyOrMonthly
					|| options.pastDueVersion !== newOptions.pastDueVersion
					|| options.includeUnactionablePOs != newOptions.includeUnactionablePOs
					|| options.includeExcludedItems != newOptions.includeExcludedItems) {
					options = newOptions;
					updateExtraParams(options);
					getData();
				}

				addExtraParamPastDueVersion();

				var state = storeService.getState();
				if (state.previousAction.type === 'modal/openModal' && state.previousAction.payload.modalType === 'itemDrilldown') {
					removeDrawerCloseListener();
					handleDrawerClose();
				}
			});

			$scope.$on('$destroy', function() {
				if (unsubscribe) unsubscribe();
			});
		});

		function getReportSettings() {
			return storeService.getState().reportSettings;
		}

		function getOptions(reportSettings) {
			if (reportSettings === undefined) {
				reportSettings = getReportSettings();
			}
			var options = reportSettings.config.options || {};
			if (options.weeklyOrMonthly === undefined) {
				options.weeklyOrMonthly = 'WEEKLY';
			}
			return options;
		}

		function updateExtraParams(options) {
			initExtraParams();
			addExtraParam('pastDueVersion', options.pastDueVersion);
			addExtraParam('weeklyOrMonthly', options.weeklyOrMonthly);
		}

		function initExtraParams() {
			// clear extra params
			meta['extraParams'].length = 0;
			baseExtraParams.forEach(function(param) {
				meta['extraParams'].push(param);
			});
		}

		function addExtraParam(name, value) {
			meta['extraParams'].push({ 'name': name, 'value': value });
		}

		function addExtraParamPastDueVersion() {
			var index = meta['extraParams'].findIndex(function(param) { return param.name === 'pastDueVersion'; });
			if (index !== -1 && meta['extraParams'][index].value === undefined) {
				meta['extraParams'][index].value = vm.pastDueDefaultDisplay;
			}
		}

		if (reportSettingsId) {
			$scope.$on('reportConfigFailed', function() {
				navigateToBaseReport();
			});
		}

		function broadcastExcel() {
			$rootScope.$broadcast('export-excel', {doChooseColumns: false});
		}

		function getMeta() {
			return meta;
		}

		function shiftPeriod(offset) {
			$scope.$broadcast('shiftPeriod', {
				offset: offset,
				index: $scope.burnoffPeriod.periodNumber + indexWeekOffset,
				barIndex: $scope.burnoffPeriod.periodNumber + barIndexWeekOffset,
				activeTab: $scope.burnoffPeriod.activeTab
			});
		}

		function handleDrawerClose() {
			hideChartBars();
			$scope.$broadcast('resetCenter');
			$timeout(function () {
				removeDrawerCloseListener();
				$scope.burnoffDrawerOpen = false;
			});
		}

		function broadcastDrawerExcel() {
			var tableWithTab = 'burnoffDrawerTable-' + $scope.burnoffPeriod.activeTab;
			var sorters = storeService.getState().leanTable.entities[tableWithTab].sorters;
			inventoryBurnoffService.startDrawerExcel($scope.burnoffPeriod.periodNumber, getOptions().weeklyOrMonthly,
				$scope.burnoffPeriod.date, $scope.burnoffPeriod.activeTab, sorters, new Date($scope.fromDate).getTime());
		}

		function openDrawer(params) {
			if (params.periodNumber !== undefined) {
				var qParams = inventoryBurnoffService.getQueryParamList(true);
				qParams.push({ key: 'drilldownPeriod', value: params.periodNumber });
				qParams.push({ key: 'fromDate', value: new Date($scope.fromDate).getTime() });
				qParams.push({ key: 'drilldownDate', value: new Date(params.date).getTime() });
				showChartBar(params.barIndex, _.camelCase(params.activeTab));
				indexWeekOffset = params.index - params.periodNumber;
				barIndexWeekOffset = params.barIndex - params.periodNumber;
				var alreadyOpen = $scope.burnoffDrawerOpen;
				$timeout(function () {
					$scope.burnoffPeriod = {
						periodNumber: params.periodNumber,
						date: params.date,
						overUnderTargetValue: params.overUnderTargetValue,
						reductionValue: params.reductionValue,
						lostPotentialValue: params.lostPotentialValue,
						activeTab: params.activeTab,
						url: inventoryBurnoffService.buildUrlWithoutParams(undefined, true),
						params: qParams,
						startDate: new Date($scope.fromDate)
					};
					$scope.burnoffDrawerOpen = true;
					if (!alreadyOpen) {
						addDrawerCloseListener();
					}
				});
				// update active tab from react store
				storeService.subscribe(function () {
					$scope.burnoffPeriod.activeTab = storeService.getState().burnoffDrawer.activeTab;
				});
			}
		}

		function showChartBar(index, barId) {
			// hide other bars if needed
			hideChartBars();
			barsShown[index] = true;
			jQuery('#burnoffChartCont').addClass('slideInOpen');
			jQuery('.c3-bars-netOpportunity .c3-bar-' + index).addClass('show-bar-click');
			jQuery('.c3-bars-lostOpportunity .c3-bar-' + index).addClass('show-bar-click');
			jQuery('.c3-bars-reductionResults .c3-bar-' + index).addClass('show-bar-click');
			jQuery('.c3-bars-' + barId + ' .c3-bar-' + index).addClass('highlight');
			jQuery('.c3-bars-' + barId + ' .c3-bar-' + index).addClass('show-bar');
			jQuery('.c3-circles-mrpValue .c3-shape-' + index).addClass('_selected_');
			jQuery('.c3-circles-ldnaTargetValue .c3-shape-' + index).addClass('_selected_');
		}

		function hideChartBars() {
			for (var key in barsShown) {
				if (barsShown[key]) {
					barsShown[key] = false;
					jQuery('#burnoffChartCont').removeClass('slideInOpen');
					jQuery('.c3-bars-netOpportunity .c3-bar-' + key).removeClass('show-bar-click');
					jQuery('.c3-bars-netOpportunity .c3-bar-' + key).removeClass('show-bar');
					jQuery('.c3-bars-netOpportunity .c3-bar-' + key).removeClass('highlight');
					jQuery('.c3-bars-lostOpportunity .c3-bar-' + key).removeClass('show-bar-click');
					jQuery('.c3-bars-lostOpportunity .c3-bar-' + key).removeClass('show-bar');
					jQuery('.c3-bars-lostOpportunity .c3-bar-' + key).removeClass('highlight');
					jQuery('.c3-bars-reductionResults .c3-bar-' + key).removeClass('show-bar-click');
					jQuery('.c3-bars-reductionResults .c3-bar-' + key).removeClass('show-bar');
					jQuery('.c3-bars-reductionResults .c3-bar-' + key).removeClass('highlight');
					jQuery('.c3-circles-mrpValue .c3-shape-' + key).removeClass('_selected_');
					jQuery('.c3-circles-ldnaTargetValue .c3-shape-' + key).removeClass('_selected_');
				}
			}
		}

		var getSettings = customerSettingService.getCustomerSettings([
			'burnoffDefaultDisplayWeeksPast',
			'burnoffDefaultDisplayWeeksFuture',
			'burnoffPastDueDefaultDisplay',
			'burnoffDistributePastDuePoTimePeriodWeeks',
			'burnoffDistributePastDuePoPercentage',
			'burnoffDistributePastDueReqTimePeriodWeeks',
			'burnoffDistributePastDueReqPercentage',
			'burnoffDottedLineStartDate'
		]).then(function (data) {
			vm.defaultWeeklyOrMonthly = 'WEEKLY';
			vm.defaultWeeksPast = data.burnoffDefaultDisplayWeeksPast;
			vm.defaultWeeksFuture = data.burnoffDefaultDisplayWeeksFuture;
			vm.pastDueDefaultDisplay = data.burnoffPastDueDefaultDisplay;
			vm.distributePastDuePoTimePeriodWeeks = data.burnoffDistributePastDuePoTimePeriodWeeks;
			vm.distributePastDuePoPercentage = data.burnoffDistributePastDuePoPercentage;
			vm.distributePastDueReqTimePeriodWeeks = data.burnoffDistributePastDueReqTimePeriodWeeks;
			vm.distributePastDueReqPercentage = data.burnoffDistributePastDueReqPercentage;
			vm.dottedLineStartDate = data.burnoffDottedLineStartDate;
			setFromDate();
			addExtraParamPastDueVersion();
			return data;
		});

		function setFromDate() {
			if (vm.dottedLineStartDate === 'pastDefault') {
				$scope.fromDate = _.max([Date.parse('2020-12-06'), inventoryBurnoffService.relDate(-1 * (vm.defaultWeeksPast || 26))]);
			} else {
				// calendarYearStart
				$scope.fromDate = moment().startOf('year').toDate();
			}
		}

		function getData() {
			if (!$scope.fiscalQuarters) {
				fiscalQuartersPromise = inventoryBurnoffService.getFiscalQuarters();
			}
			var promises = [
				getSettings,
				inventoryBurnoffService.getChartData(),
				fiscalQuartersPromise
			];

			tableService.trackPageView(vm.reportSettingsName, leanFilterService.getFactoryList());
			
			return Promise.all(promises).then(function (values) {
				var settings = values[0],
					response = values[1];

				$scope.fiscalQuarters = values[2];

				$scope.loading = false;
				$scope.initialLoad = false;

				$scope.defaultWeeklyOrMonthly = 'WEEKLY';
				$scope.defaultWeeksPast = (typeof settings.burnoffDefaultDisplayWeeksPast !== 'undefined')
					? settings.burnoffDefaultDisplayWeeksPast : 26;
				$scope.defaultWeeksFuture = (typeof settings.burnoffDefaultDisplayWeeksFuture !== 'undefined')
					? settings.burnoffDefaultDisplayWeeksFuture : 26;
				$scope.pastDueDefaultDisplay = (typeof settings.burnoffPastDueDefaultDisplay !== 'undefined')
					? settings.burnoffPastDueDefaultDisplay : 1;
				$scope.distributePastDuePoTimePeriodWeeks = (typeof settings.burnoffDistributePastDuePoTimePeriodWeeks !== 'undefined')
					? settings.burnoffDistributePastDuePoTimePeriodWeeks : 1;
				$scope.distributePastDuePoPercentage = (typeof settings.burnoffDistributePastDuePoPercentage !== 'undefined')
					? settings.burnoffDistributePastDuePoPercentage : 100;
				$scope.distributePastDueReqTimePeriodWeeks = (typeof settings.burnoffDistributePastDueReqTimePeriodWeeks !== 'undefined')
					? settings.burnoffDistributePastDueReqTimePeriodWeeks : 1;
				$scope.distributePastDueReqPercentage = (typeof settings.burnoffDistributePastDueReqPercentage !== 'undefined')
					? settings.burnoffDistributePastDueReqPercentage : 100;
				$scope.dottedLineStartDate = (typeof settings.burnoffDottedLineStartDate !== 'undefined')
					? settings.burnoffDottedLineStartDate : 'calendarYearStart';

				if (!response || !response.length || response.length !== 2 || jQuery.isEmptyObject(response[0])) {
					$scope.empty = true;
				} else {
					$scope.empty = false;
					$scope.chartData = response[0];

					$scope.maxPeriod = $scope.chartData.projData.length;
					var pastData = response[1].data;
					if (pastData && pastData.length === 27) {
						// Sometimes there are 27 data points in the history, we're only going to use latest 26
						pastData.shift();
					}
					$scope.minPeriod = 26 - pastData.length + 1;

					$scope.showChangeTargets = false;
					if (isAdmin) {
						_.forEach($scope.chartData.sitesWithNoTarget, function (value, key) {
							if ($scope.siteId === parseInt(value.siteId)) {
								$scope.showChangeTargets = true;
							}
						});
					}

					var missingTargetCount = $scope.chartData.sitesWithNoTarget.length;
					$scope.multipleSitesMissingTargets = missingTargetCount > 1;

					var i;
					if (missingTargetCount !== 0) {
						var message = 'Fiscal year targets have not been set for ';
						if (missingTargetCount === 1) {
							message += $scope.chartData.sitesWithNoTarget[0];
						} else {
							message += 'these sites: ';
							for (i = 0; i < missingTargetCount; i++) {
								if (i < missingTargetCount - 1) {
									message += $scope.chartData.sitesWithNoTarget[i] + ', ';
								} else {
									message += 'and ' + $scope.chartData.sitesWithNoTarget[i];
								}
							}
						}
						$scope.missingTargetMessage = message;
					}

					var options = getOptions();
					var foundOnHandValue = false;
					// combine past-week values from burnoff and wli
					var pastDataOffset = 26 - pastData.length;
					for (i = pastData.length - 1; i >= 0; i--) {
						var periodNumber = i + pastDataOffset;
						var weeklyValues = $scope.chartData.projData[periodNumber];

						if (options.weeklyOrMonthly === 'WEEKLY') {
							if (periodNumber < 26) {
								weeklyValues.periodEndDate = pastData[i].dateLog;
								weeklyValues.mrpValue = pastData[i].totalOnHandValue;
								weeklyValues.pastDueReqs = pastData[i].pastDueRequirementValue;
								weeklyValues.pastDuePOs = pastData[i].pastDuePOValue;
							}
						}

						// join blue line to orange line at last available totalOnHandValue
						if (pastData[i].hasOwnProperty('totalOnHandValue') && !foundOnHandValue) {
							foundOnHandValue = true;
							if (options.weeklyOrMonthly === 'WEEKLY') {
								weeklyValues.ldnaTargetValue = pastData[i].totalOnHandValue;
							} else {
								var firstBurnoffDate = moment($scope.chartData.projData[0].periodEndDate);
								var lastHistoryDate = moment(pastData[i].dateLog);
								if (firstBurnoffDate.isSame(lastHistoryDate, 'day')) {
									$scope.chartData.projData[0].mrpValue = pastData[i].totalOnHandValue;
									$scope.chartData.projData[0].ldnaTargetValue = pastData[i].totalOnHandValue;
								} else {
									$scope.chartData.projData.unshift({
										periodEndDate: pastData[i].dateLog,
										mrpValue: pastData[i].totalOnHandValue,
										ldnaTargetValue: pastData[i].totalOnHandValue
									});
								}
								break;
							}
						}
					}
					angular.forEach($scope.chartData.projData, function (d) {
						d['periodEndDate'] = new Date(d['periodEndDate']);
					});

					$scope.$broadcast('burnoffChartDataReady');
				}
				$timeout(function() {
					pageTimingService.submitUserTiming('Inventory Burnoff');
				});
				return response;
			});
		}

		function addDrawerCloseListener() {
			jQuery('body').on('click.burnoffDrawer', function (event) {
				var target = jQuery(event.target);
				if (target.closest('body').length
					&& !target.closest('.MuiDrawer-root').length
					&& !target.closest('.MuiPopover-root').length) {
					handleDrawerClose();
				}
			});
		}

		function removeDrawerCloseListener() {
			jQuery('body').off('click.burnoffDrawer');
		}

		function init() {
			$scope.isSupplierPortal = (globalConfig.user.role === 'Supplier');
			$scope.filterService.clearFilters();
			$scope.filterService.setMasterFilterList([]);
			$scope.filterService.setMasterRangeFilterList([]);
			$scope.filterService.setMasterStringFilterList([]);
			$scope.filterService.setMasterSingleSelectFilterList([]);
			$scope.filterService.useFactoryFilter = true;
			$scope.siteName = globalConfig.factory.alias;
			$scope.siteId = globalConfig.factory.id;
			$scope.dontShowTargetWarning = true;

			if (!isSupplierPortal) {
				var siteFilter = leanFilterService.filterDefinitions['Factory'];
				siteFilter.type = 'multiselect';
				siteFilter.removable = false;
				$scope.filterService.setMasterFilterList([
					$scope.filterService.filterDefinitions['BusinessUnit'],
					$scope.filterService.filterDefinitions['Division'],
					$scope.filterService.filterDefinitions['Entity'],
					siteFilter,
					$scope.filterService.filterDefinitions['Item Group'],
					$scope.filterService.filterDefinitions['ItemType'],
					$scope.filterService.filterDefinitions['Supplier'],
					$scope.filterService.filterDefinitions['Buyer'],
					$scope.filterService.filterDefinitions['Planner'],
					$scope.filterService.filterDefinitions['ERP Order Policy'],
					$scope.filterService.filterDefinitions['TaskStatus'],
					$scope.filterService.filterDefinitions['TaskCategory'],
					$scope.filterService.filterDefinitions['MaterialGroup'],
					$scope.filterService.filterDefinitions['MaterialType']
				]);
			} else {
				$scope.filterService.setMasterFilterList(
					[$scope.filterService.filterDefinitions['ERP Order Policy']]);
			}
		}
	}
})();
